var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"heim-toast",class:[_vm.toastOpened?'opened':'', _vm.toastMode]},[_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.$t(_vm.toastMessage)))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }